import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';

import { abConversionMiddleware } from '../../middleware/abConversion';
import { analyticsLogger } from '../../middleware/google-analytics';
import { pageCategoryMiddleware } from '../../middleware/pageCategory';
import { branchTrackerMiddleware } from '../../middleware/branch-middleware';

export default pageName => {
    return [
        thunkMiddleware,
        abConversionMiddleware,
        pageCategoryMiddleware(pageName),
        analyticsLogger,
        routerMiddleware(browserHistory),
        branchTrackerMiddleware,
    ];
};
